<template>
  <BaseModal ref="modal">
    <UiModalDialog
      class="jps-thumb-modal"
      :no-footer="true"
    >
      <div class="jps-modal-content">
        <a
          class="thumbpg"
          v-for="(img, ind) in _imageList"
          :key="ind"
          @click="select(ind + 1)"
        >
          <img v-lazy="img" :src="img" />
        </a>
      </div>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import vLazy from 'vue3-lazyload'
import type { BaseModal } from '#components'

interface Props {
  imageList?: string[]
}
const props = withDefaults(defineProps<Props>(), {
})

const modal = ref<InstanceType<typeof BaseModal>>()
const _imageList: Ref<string[]> = ref([])
const openAwait = async (options?: Props) => {
  setOptionsValue(_imageList, 'imageList', props, options)
  return await modal.value.openAwait<number>()
}
defineExpose({ openAwait })

const select = (index: number) => {
  modal.value.resolve(index)
}
</script>

<style lang="scss" scoped>
.jps-thumb-modal {
  .jps-modal-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .thumbpg {
      margin: 10px;
      width: 200px;
      min-height: 150px;
    }
  }
}
</style>
